import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';

/* ── Icons ─────────────────────────────────────────────────────── */
const HomeIcon   = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const AboutIcon  = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const EventsIcon = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const BooksIcon  = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>;
const DonateIcon = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>;
const ProfileIcon= ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const SignInIcon = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>;
const JoinIcon   = ({ a }) => <svg className="vrv-bottom-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={a?2.2:1.8} strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>;

const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const isActive = (p) => pathname === p;

  /* Before login: Home · About · Events · Sign In · Join Us
     After login:  Home · Events · Books  · Donate  · Profile  */
  const items = isAuthenticated
    ? [
        { path: '/',        label: 'Home',    Icon: HomeIcon },
        { path: '/events',  label: 'Events',  Icon: EventsIcon },
        { path: '/books',   label: 'Books',   Icon: BooksIcon },
        { path: '/donate',  label: 'Donate',  Icon: DonateIcon },
        { path: '/profile', label: 'Profile', Icon: ProfileIcon },
      ]
    : [
        { path: '/',         label: 'Home',    Icon: HomeIcon },
        { path: '/about',    label: 'About',   Icon: AboutIcon },
        { path: '/events',   label: 'Events',  Icon: EventsIcon },
        { path: '/login',    label: 'Sign In', Icon: SignInIcon },
        { path: '/signup',   label: 'Join Us', Icon: JoinIcon },
      ];

  return (
    <nav className="vrv-bottom-nav" aria-label="Mobile primary navigation">
      {items.map(({ path, label, Icon }) => {
        const active = isActive(path);
        return (
          <Link
            key={path}
            to={path}
            className={`vrv-bottom-nav-item${active ? ' active' : ''}`}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            <Icon a={active} />
            <span className="vrv-bottom-nav-label">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
